module.exports = __webpack_public_path__ + "static/media/plantechdesign.29475a00.png";